/**
 * HeaderTopbar
 * Slim bar above the main header showing the public email. Phone is hidden
 * until a real number is confirmed.
 */
import React from 'react';
import { MASJID } from '../../config/masjid';
import './style.css';

const HeaderTopbar = () => {
  return (
    <div className="topbar">
      <div className="container">
        <div className="row">
          <div className="col col-md-6 col-sm-12 col-12">
            <div className="contact-intro">
              <ul>
                {/* TODO: Restore phone here when a public masjid phone number is confirmed. */}
                <li>
                  <i className="fi flaticon-envelope"></i>{' '}
                  <a href={`mailto:${MASJID.contactEmail}`}>
                    {MASJID.contactEmail}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTopbar;
